import { queryDpMessage } from '@tencent/wphk-components-dp-loader';
import { HomeDpPositions, DP_PAGE, HotNews } from '@/types/home-newest';
import { getMultiLangAttr } from '@/business/home-newest';
import { DpItem } from '@tencent/wphk-components-dp-loader/src/types';
import { getHomeBiExt } from '@/business/home-bi-helper';

/**
 * 格式化热门资讯数据
 */
function handleHotNewsList(data: DpItem[] = []) {
  const result: HotNews[] = data.map((item, index) => {
    const { url, title, logo, desc, tagList = [] } = item.contentBaseData as any;

    // 资讯标签
    const formatTagList = (tagList || []).map(item => ({
      text: getMultiLangAttr(item),
      type: item.type,
    }));
    return {
      url,
      title: getMultiLangAttr(title),
      logo,
      id: item.dpId,
      desc: getMultiLangAttr(desc),
      tagList: formatTagList,
      reportInfo: getHomeBiExt(item, {
        fnews_no: `${index + 1}`,
        fdp_hkdesc: title.hk,
      }),
    };
  });
  return result;
}

/**
 * 获取热门资讯数据
 */
export async function getHotNewsList() {
  const dpMessageRes = await queryDpMessage({
    dpPage: DP_PAGE,
    dpPositions: [HomeDpPositions.HotNews],
  });
  return handleHotNewsList(dpMessageRes?.dpList);
}
